(function ($) {
  Drupal.behaviors.myplate_dropdowns = {
    attach: function (context, settings) {

      $(once('mp-dropdown-trigger', '[data-mp-dropdown-trigger]', context))
        .each((i, el) => {
          const $trigger = $(el);
          tippy($trigger.get(), {
            onTrigger(instance, event) {
              // We want to be able to apply analytics events!
              // event.preventDefault();
            },
            onShow(instance) {
              const dropdown = instance.popper,
                trigger = instance.reference;
              const dropdownWidth = trigger.getBoundingClientRect().width;
              dropdown.style.minWidth = dropdownWidth + "px";
              trigger.style.minWidth = dropdownWidth + "px";
              // dropdown.style.zIndex = 1;
              trigger.style.zIndex = 2;

              var box = instance.popper.firstChild.firstChild;
              if (!box.childElementCount) {
                // Reattach the content.
                box.appendChild(instance.props.content);
              }
            },
            onCreate(instance) {
              instance.mpHiddenContainer = $(
                '<div class="display-none"></div>'
              ).get(0);
              instance.mpHiddenContainer.appendChild(instance.props.content);
              instance.reference.parentNode.appendChild(
                instance.mpHiddenContainer
              );
            },
            onHidden(instance) {
              const trigger = instance.reference;
              trigger.style.minWidth = 0;
              // Keep content in dom.
              instance.mpHiddenContainer.appendChild(instance.props.content);
            },
            content(trigger) {
              const targetId = $(trigger).attr("aria-controls"),
                $el = $(`#${targetId}`);
              if ($el.length) {
                $el.show();
                const el = $el[0];
                const behavior_settings = settings || drupalSettings;
                Drupal.attachBehaviors(el, behavior_settings);
                return el;
              }

              return null;
            },
            theme: "mp-dropdown",
            allowHTML: true,
            trigger: "click",
            placement: "bottom",
            arrow: false,
            offset: [0, 0],
            interactive: true,
            animation: false,
            zIndex: 510,
          });
        });

    },
  };
})(jQuery);
